import { observer } from 'mobx-react-lite'
import React from 'react'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import {
  Box,
  Divider,
  type IDropdownItem,
  PhoneWithLabelInput,
  TextFieldWithLabel,
} from 'shared/ui'
import { LINK_CALL_FORWARDING_GUIDE } from 'shared/constants/links'
import { SendFromBlockActionEditContent } from 'widgets/Flow/blocks/SendFrom'
import { type NumberSettingStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/store/NumberSettingStore'
import {
  NumberWhisper,
  WHISPER_SCREENING_DISABLED_TOOLTIP,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/NumberWhisper/NumberWhisper'
import styles from './styles.module.scss'
import { ToggleCard } from './ToggleCard/ToggleCard'

export const NumberSetting = observer(({ store }: { store: NumberSettingStore }) => {
  const {
    forwardTo,
    setForwardTo,
    forwardToError,
    sendFromBlockStore,
    extension,
    setExtension,
    screening,
    setScreening,
    numberWhisperStore,
    externalPhoneInputStore,
    isWhisperScreeningDisabled,
    setExternalNumber,
  } = store

  const forwardItems: IDropdownItem<typeof forwardTo>[] = [
    { id: 'inbox', label: 'Salesmsg inbox' },
    { id: 'externalNumber', label: 'External number' },
  ]

  return (
    <div>
      <div className={styles.wrapForward}>
        <SelectField
          selectProps={{
            variant: 'stroke',
            textFieldPlaceholderProps: {
              size: 'medium',
            },
          }}
          withSearch={false}
          size={'medium'}
          labelText={'Forward to'}
          items={forwardItems}
          value={forwardTo}
          setValue={setForwardTo}
          error={forwardToError}
        />
      </div>

      {forwardTo === 'inbox' && (
        <SendFromBlockActionEditContent store={sendFromBlockStore} labelText={'Select inbox'} />
      )}
      {forwardTo === 'externalNumber' && (
        <Box display='flex' justifyContent='space-between' gap={'12px'}>
          <Box flex={1}>
            <PhoneWithLabelInput
              isNoMarginTopInputLabel
              label={'Phone number'}
              item={externalPhoneInputStore.country}
              items={externalPhoneInputStore.countries}
              number={externalPhoneInputStore.number}
              numberError={externalPhoneInputStore.numberError}
              isValidNumber={externalPhoneInputStore.isValidNumber}
              numberRequestError={externalPhoneInputStore.numberRequestError}
              setNumber={setExternalNumber}
              setCountry={externalPhoneInputStore.setCountry}
              triggerNumberValidation={externalPhoneInputStore.triggerNumberValidation}
            />
          </Box>
          <Box width={'90px'}>
            <TextFieldWithLabel
              labelProps={{
                label: {
                  text: 'Extension',
                },
              }}
              errorMessage={''}
              textFieldProps={{
                onChange: setExtension,
                value: extension,
                InputProps: {
                  placeholder: '123',
                },
              }}
            />
          </Box>
        </Box>
      )}
      {forwardTo && (
        <div className={styles.actions}>
          <NumberWhisper store={numberWhisperStore} />
          {!numberWhisperStore.active && <Divider />}
          <ToggleCard
            title={'Call Screening'}
            labelTooltip={
              <>
                Prevents surprise calls by <br /> requiring confirmation.
                <br />
                <a href={LINK_CALL_FORWARDING_GUIDE} target='_blank' rel='noreferrer'>
                  Learn more
                </a>
              </>
            }
            description={"Asks the receiver to accept the call before it's connected"}
            value={screening}
            setValue={setScreening}
            disabled={isWhisperScreeningDisabled}
            disabledTooltip={<>{WHISPER_SCREENING_DISABLED_TOOLTIP}</>}
          />
        </div>
      )}
    </div>
  )
})
